"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Parser = require("../core/jsonParser");
var jsonCompletions_1 = require("./jsonCompletions");
var jsoncompletion = new jsonCompletions_1.JSONCompletion();
function getCompletionsAtPosition(model, position) {
    var doc = Parser.parse(model.getValue());
    var normalCompletions = jsoncompletion.doComplete(model, position, doc);
    return normalCompletions;
}
exports.getCompletionsAtPosition = getCompletionsAtPosition;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/monaco/languages/json/service/jsonCompletions2.js
 ** module id = 433
 ** module chunks = 0
 **/